import { Group, Text, Stack, Box, Anchor } from '@mantine/core';
import { IconVideo as IconVideoTabler, IconMapPin as IconMapPinTabler, IconExternalLink as IconExternalLinkTabler } from '@tabler/icons-react';
import { Divider } from '@mantine/core';
import { LeaderSessionView } from '@actschurch/ccms-sdk';
import { ColorBadge } from './ColorBadge';

interface LeaderSessionDetailsProps {
  session: LeaderSessionView;
}

export default function LeaderSessionDetails({ session }: LeaderSessionDetailsProps) {
  return (
    <>
      <Divider
        label={<Text size="sm" fw={600}>Session details</Text>}
        labelPosition="center"
        mb="md"
      />
      <Stack gap="md">
        <Group gap="xs">
          <ColorBadge label={session.typeName ?? 'N/A'} color={session.typeColor} />
          <ColorBadge label={session.statusName ?? 'N/A'} color={session.statusColor} />
        </Group>

        <Group gap="xl">
          <Box>
            <Text size="xs" c="dimmed">Date</Text>
            <Text size="sm">{session.sessionDateDisplay ?? '—'}</Text>
          </Box>
          <Box>
            <Text size="xs" c="dimmed">Mode</Text>
            <Group gap={4}>
              {session.link ? <IconVideoTabler size={14} /> : <IconMapPinTabler size={14} />}
              <Text size="sm">{session.link ? 'Virtual' : 'In person'}</Text>
            </Group>
          </Box>
        </Group>

        {session.link && (
          <Anchor href={session.link} target="_blank" size="sm">
            <Group gap={4}>
              <IconExternalLinkTabler size={14} />
              Join virtual link
            </Group>
          </Anchor>
        )}

        {session.locationName && (
          <Box>
            <Text size="xs" c="dimmed">Location</Text>
            <Text size="sm">{session.locationName}</Text>
          </Box>
        )}

        {session.caseNames && (
          <Box>
            <Text size="xs" c="dimmed" mb={4}>Linked cases</Text>
            <Text size="sm">{session.caseNames}</Text>
          </Box>
        )}
      </Stack>
    </>
  );
}